// extracted by mini-css-extract-plugin
export var connectionButton = "_br-1";
export var connectionButtonFloating = "_br-2";
export var connectionContainer = "_br-0";
export var rightPanel = "_br-6";
export var stepCard = "_br-3";
export var stepCardSubtitle = "_br-5";
export var stepCardText = "_br-4";